import Vue from 'vue'
import Router from 'vue-router'
import {store} from '@/store/store';

import MainLayout from '@/components/layouts/Main'
import NotFoundView from '@/components/error/404.vue'

import Dashboard from '@/components/view/dashboard/Dashboard'
import Account from '@/components/view/allbots/Account'
import Livechat from '@/components/view/livechat/Livechat'
import About from '@/components/view/about/About'
import Setting from '@/components/view/setting/Setting'
import Template from '@/components/view/template/Template'
import Chatbot from '@/components/view/chatbot/Chatbot'
import Intent from '@/components/view/intent/Intent'

import OrderSummaryLine from "@/components/view/template/ecommerce/OrderSummaryLine";
import Chat from "@/components/view/chat/Chat";

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: function (resolve) {
      require(['@/components/login/Login.vue'], resolve)
    }
  },
  {
    path: '/nigol',
    name: 'nigol',
    component: function (resolve) {
      require(['@/components/login/Nigol.vue'], resolve)
    }
  },
  {
    path: '/allbots',
    name: 'allbots',
    component: Account,
    beforeEnter: guardRoute,
    meta: {
      title: 'All Bots'
    }
  },
  {
    path: '/ordersummary',
    name: 'ordersummary',
    component: OrderSummaryLine,
    // beforeEnter: guardRoute,
    meta: {
      title: 'Order Summary'
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: Chat,
    // beforeEnter: guardRoute,
    meta: {
      title: 'Chat'
    }
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '/',
        redirect: '/allbots'
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: '/livechat',
        name: 'livechat',
        component: Livechat,
        beforeEnter: guardRoute,
        meta: {
          title: 'Live Chat'
        }
      },
      {
        path: '/about',
        name: 'about',
        component: About,
        beforeEnter: guardRoute,
        meta: {
          title: 'About'
        }
      },
      {
        path: '/setting',
        name: 'setting',
        component: Setting,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: '/template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Bot Content'
        }
      },
      {
        path: '/chatbot',
        name: 'chatbot',
        component: Chatbot,
        beforeEnter: guardRoute,
        meta: {
          title: 'Chatbot'
        }
      },
      // {
      //   path: '/broadcast',
      //   name: 'broadcast',
      //   component: Broadcast,
      //   beforeEnter: guardRoute,
      //   meta: {
      //     title: 'Broadcast'
      //   }
      // },
      {
        path: '/intent',
        name: 'intent',
        component: Intent,
        beforeEnter: guardRoute,
        meta: {
          title: 'Intents'
        }
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default new Router({
  routes,
  mode: 'history'
})

function guardRoute (to, from, next) {

  if (!store.getters.isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        
        store.dispatch('updateBotDetail').then(
          function (response) {
            // console.log(response)
          }, function (error) {
            next({
              path: '/login',
              query: { redirect: to.fullPath }
            })
          })
      }
      next()
      
    } else {
      if (store.state.selectedBot) {

        store.dispatch('updateBotDetail').then(
          function (response) {
            // console.log(response)
          }, function (error) {
            next({
              path: '/nigol',
              query: { redirect: to.fullPath }
            })
          })
      }

      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js